"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _striptags = _interopRequireDefault(require("striptags"));
var _he = require("he");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(args) {
  // handle WYSIWYG object properly
  args = (0, _isObject2["default"])(args) && args.content ? {
    text: args
  } : args;
  args = (0, _isString2["default"])(args) ? {
    text: args
  } : args;
  var _args = args,
    _args$text = _args.text,
    text = _args$text === void 0 ? '' : _args$text,
    _args$length = _args.length,
    length = _args$length === void 0 ? 40 : _args$length,
    _args$appendix = _args.appendix,
    appendix = _args$appendix === void 0 ? ' ...' : _args$appendix;
  if ((0, _isObject2["default"])(text)) {
    text = text.content || '';
  }
  text = (0, _he.decode)((0, _striptags["default"])(text).replace('&nbsp;', ' '));
  if (text.length <= length) {
    return text;
  }
  return text.substr(0, length - appendix.length) + appendix;
};